import { render, staticRenderFns } from "./ManagerCampPlacementSleepingHouses.vue?vue&type=template&id=5bcf8eb6&lang=pug&"
import script from "./ManagerCampPlacementSleepingHouses.vue?vue&type=script&lang=js&"
export * from "./ManagerCampPlacementSleepingHouses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports